import { FunctionalComponent, h } from "preact";

import Home from "../routes/home";

const App: FunctionalComponent = () => {
    return (
        <div id="app">
            <Home />
        </div>
    );
};

export default App;
